import React from "react";
import ContentArea from "../components/content-area/Content";
import EventList from "../components/events/EventList";
import EventIconPng from "../assets/icons/events.png";

const Events = () => (
  <ContentArea title="Events" icon={EventIconPng} container={false}>
    <EventList />
  </ContentArea>
);

export default Events;
